import { Fragment } from "react";
import { withStyles, IconButton } from "@material-ui/core";
import Tooltip from "../../../../common/StyledToolTip";
import constants from "../../../../../appConstants";
import { TimeRangeEditor } from '@dataGrid/components/cellEditors';
import EventBusyOutlined from "@material-ui/icons/EventBusyOutlined";
import capitalize from "lodash/capitalize";
import { MoreTimeOutlined } from "../../../Common/icons";

export const closedDayTime = "00:00 - 00:00";

const styles = (theme) => ({
  dayNameStyle: {
    minHeight: 40,
    display: "flex",
    alignItems: "center",
  },
  timeRangeEditorStyle: {
    marginBottom: 10,
    marginLeft: -5,
  },
  receivingHoursError: {
    color: theme.ErrorMessageColor,
  },
  closeIcon: {
    "&:hover": {
      color: theme.error,
    },
    color: theme.iconColor,
    padding: 4
  },
  iconContainer: {
    marginLeft: 12
  },
  disableCloseIcon: {
    opacity: 0.7
  },
  tooltipWrapper: {
    display: 'inline-block'
  }
});

export const DateTime = (props) => {
  const updateTime = (time) => {
    if (time !== constants.INVALID_TIME_RANGE  && props.time !== time) {
      props.updateTime(props.index, time);
    }
  };
  return (
    <TimeRangeEditor
      DATETYPE={constants.DATETYPES.TIME}
      isTimeInterval={true}
      value={props.time}
      onChange={updateTime}
      componentSpecificProps={{
        isClosedDay: props.isClosedDay,
        startLabel: "Opens at",
        endLabel: "Closes at",
        isInputBorderRequired: false,
        autoFocus: props.autoFocus
      }}
    />
  );
};

const ReceivingHours = (props) => {
  const {
    dayName,
    dayIndex,
    hours,
    updateHours,
    errors,
    classes,
    defaultHours,
    enableMultipleTimeWindows
  } = props;
  const markDayAsClosed = () => {
    updateHours(dayName, [closedDayTime]);
  };

  const updateTime = (index, time) => {
    if (time === closedDayTime) {
      markDayAsClosed();
      return;
    }
    const newHours = hours.slice();
    newHours[index] = time;
    updateHours(dayName, newHours);
  };

  const [, defaultHours2] = defaultHours;
  const addHours = () => {
    updateHours(dayName, [...hours, defaultHours2? defaultHours2: ""]);
  };
  const isClosedDay = hours.length === 1 && hours[0] === closedDayTime;
  const isDisabledAddMoreReceivingHours = hours.length >= 2;
  return (
    <Fragment>
      <div className={classes.dayNameStyle}>
        {capitalize(dayName)}
        {!isClosedDay ? (
          <div className={classes.iconContainer}>
            <Tooltip
              title={
                enableMultipleTimeWindows
                  ? 'Add Additional Receiving Hours'
                  : 'Multiple shipper time windows are not enabled'
              }
            >
              <span className={classes.tooltipWrapper}>
                <IconButton
                  onClick={addHours}
                  classes={{ root: classes.closeIcon }}
                  disabled={isDisabledAddMoreReceivingHours || !enableMultipleTimeWindows}
                  className={isDisabledAddMoreReceivingHours ? classes.disableCloseIcon : ''}
                >
                  <MoreTimeOutlined />
                </IconButton>
              </span>
            </Tooltip>
            <Tooltip title="Mark Closed">
              <IconButton
                onClick={markDayAsClosed}
                classes={{ root: classes.closeIcon }}
                id="markClosed"
              >
                <EventBusyOutlined />
              </IconButton>
            </Tooltip>
          </div>
        ) : null}
      </div>
      {hours.map((hour, index) => (
        <div key={index}>
          <div className={classes.timeRangeEditorStyle}>
            <DateTime
              isClosedDay={isClosedDay}
              time={hour}
              index={index}
              key={`${dayName}_${isClosedDay}`}
              updateTime={updateTime}
              autoFocus={dayIndex === 0}
            />
          </div>
          {errors?.[index] ? (
            <div className={classes.receivingHoursError}>{errors?.[index]}</div>
          ) : null}
        </div>
      ))}
    </Fragment>
  );
};
export default withStyles(styles)(ReceivingHours);
